﻿
export default class ErrorPage {
    constructor() {

    }
}
